<template>
  <div class="horse__content">
    <vue-audio :file="8" ref="horseRun" :loop="true"></vue-audio>
    <vue-audio :file="9" ref="raceTextGoal"></vue-audio>
    <div class="horse" :id="id" :class="status + ' horse-0' + horseData.color"></div>
  </div>
</template>

<script>
  import { store } from '../store/store'
  import _ from 'lodash'
  import Audio from './Audio'
  export default {
    name: 'House',
    data () {
      return {
        horseID: 0,
        timeLine: -1,
        TM1: -1,
        status: 'stand'
      }
    },
    components: {
      'vue-audio': Audio
    },
    computed: {
      runHouseStatus () {
        return this.id === 'user' ? store.state.raceStage.user : store.state.raceStage.pc
      },
      horseData () {
        return this.id === 'user' ? store.state.horseUser : store.state.horsePc
      },
      distanceFinalTurn () {
        return this.id === 'user' ? store.state.finalDistanceA : store.state.finalDistanceB
      },
      checkPauseOnFinish () {
        return store.state.finalDistanceA >= 2000 || store.state.finalDistanceB >= 2000
      },
      resetStatus () {
        return store.state.resetStatus
      }
    },
    methods: {
      onComplete () {
        // Stop audio
        this.$refs.horseRun.stop()
        // Stop run
        this.timeLine.pause()
        this.setHouseStand()
        if (this.id === 'user') {
          store.dispatch('setPcDiceStatus', true)
          if (!this.checkPauseOnFinish) {
            store.dispatch('setDiceRun', {
              'currentDice': 'pc',
              'diceStatus': true
            })
          }
        } else {
          store.dispatch('setPcDiceStatus', false)
        }
        store.dispatch('setHorseRun', {
          'currentHorse': this.id,
          'raceStatus': false
        })
        if (this.distanceFinalTurn >= 2000) {
          store.dispatch('showRaceTextGoal', true)
          // Play audio
          this.$refs.raceTextGoal.play()
        }
      },
      setTweenLite () {
        this.status = 'run'
        this.timeLine = new TimelineMax()
        TweenMax.set('#' + this.id, {backgroundPosition: '0'})
        this.TM1 = TweenMax.to('#' + this.id, 0.4, {repeat: -1, backgroundPosition: '-382px', ease: SteppedEase.config(2)})
        this.timeLine.append(this.TM1)
        this.timeLine.pause()
      },
      setHouseStart () {
        TweenMax.set('#' + this.id, {x: '-10'})
        this.setHouseStand()
      },
      setHouseStand () {
        this.status = 'stand'
        TweenMax.set('#' + this.id, {backgroundPosition: 'auto'})
      },
      changeHouse () {
        this.houseID = this.houseID < 7 ? this.houseID + 1 : 0
      },
      run () {
        this.setTweenLite()
        let distance = _.round(_.round(this.distanceFinalTurn) * _.round(750 / 2000, 2))
        distance = distance > 750 ? 750 : distance
        let go = TweenMax.to('#' + this.id, 2, {x: distance + 'px', onComplete: this.onComplete, ease: Power3.easeNone})
        this.timeLine.append(go)
        this.timeLine.play()
        // Play audio
        this.$refs.horseRun.play()
      },
      pause () {
        this.setHouseStand()
        this.timeLine.pause()
      },
      timeScale: function (x) {
        TweenLite.set(this.TM1, {timeScale: x})
      }
    },
    mounted () {
      this.setTweenLite()
      this.setHouseStart()
    },
    props: ['id'],
    watch: {
      runHouseStatus () {
        if (this.runHouseStatus) {
          this.run()
        }
      },
      resetStatus (val) {
        if (val) {
          this.timeLine.pause()
          this.timeLine.kill()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Horse.vue?2b46bd2e